import { useState } from "react"

import classNames from "classnames"
import { post } from "shared/lib/api"

import "./exclusive_offer.scss"

interface UserSubscription {
  hasDiscount: boolean
  paymentInterval: "month" | "year"
  tier: string
}

interface Props {
  asset: string
  claimOfferUrl: string
  exploreUrl: string
  handleCancellation: func
  trackMutationError: func
  userSubscription: UserSubscription
}

const ExclusiveOffer = ({
  asset,
  claimOfferUrl,
  exploreUrl,
  handleCancellation,
  trackMutationError,
  userSubscription,
}: Props) => {
  const [loading, updateLoading] = useState(false)
  const errorMessage = "There was a problem claiming your offer. Please contact support for more information."

  let title: string, offerCopy: string, warningCopy: string, discountPercentage: string, successCopy: string

  if (userSubscription.paymentInterval === "year") {
    if (userSubscription.tier === "pro") {
      discountPercentage = "10"
    } else {
      discountPercentage = "5"
    }

    title = "Exclusive offer"
    if (userSubscription.hasDiscount) {
      warningCopy = "This will replace any existing promotions on your account."
    }
    offerCopy = `Get ${discountPercentage}% off your next payment.`
    successCopy = `You got ${discountPercentage}% off for your next payment!`
  } else {
    title = "Switch to annual"
    offerCopy =
      "Get 3 months free when you move to annual billing. Your account will be updated and billed today, minus a credit for any remaining days on your current plan."
    successCopy = "You are saving more with annual billing!"
  }

  const handleOffer = () => {
    updateLoading(true)
    post(claimOfferUrl)
      .then(data => {
        if (data.ok) {
          window.appendFlash(successCopy, "success", () => {
            window.location.assign(exploreUrl)
          })
        } else {
          trackMutationError("userSubscriptionPromoCodeUpdate", data.error, errorMessage, updateLoading)
        }
      })
      .catch(error => {
        trackMutationError("userSubscriptionPromoCodeUpdate", error, errorMessage, updateLoading)
      })
  }

  return (
    <div>
      <h1 className="mt4 mb4 mb2--phone mb2--small-phone">{title}</h1>

      <p className={classNames("mt0", { mb4: !warningCopy })}>{offerCopy}</p>
      {warningCopy && (
        <p className="mt0 mb4" styleName="exlusive-offer-warning">
          {warningCopy}
        </p>
      )}

      <img src={asset} width="288" height="256" />

      <div className="cancellation-actions mt4 mt8--phone mt8--small-phone">
        <button className="button-primary" onClick={handleOffer} disabled={loading}>
          Claim offer
        </button>
        <a className={`link-standalone mt4 ${loading && "disabled"}`} onClick={() => handleCancellation(updateLoading)}>
          No thanks, just cancel my subscription
        </a>
      </div>
    </div>
  )
}

export default ExclusiveOffer
